function initDIGBHomeGridExtras(jsonUrl) {
  fetch(jsonUrl)
    .then(response => response.json())
    .then(data => {
      const container = document.getElementById('digb-home-grid-extras');
      if (!container) return;
      
      // Clear any existing content
      container.innerHTML = '';
      
      // Filter out the categories we want to exclude
      const excludedCategories = ['BUCKETS', 'DITCHING', 'TRENCHING'];
      const filteredData = {};
      Object.keys(data).forEach(categoryKey => {
        if (!excludedCategories.includes(categoryKey)) {
          filteredData[categoryKey] = data[categoryKey];
        }
      });
      
      // Create the main UL element
      const ul = document.createElement('ul');
      ul.className = 'digb-home-grid-list';
      
      // Process each category in the filtered JSON
      Object.keys(filteredData).forEach(categoryKey => {
        const category = filteredData[categoryKey];
        const li = document.createElement('li');
        li.className = 'digb-home-grid-item';
        
        // Create a link for the category
        const categoryLink = document.createElement('a');
        categoryLink.href = category.link;
        categoryLink.className = 'digb-home-grid-category-link';
        categoryLink.textContent = categoryKey;
        
        // Create a nested UL for children
        const childrenUl = document.createElement('ul');
        childrenUl.className = 'digb-home-grid-children';
        
        // Process each child item
        category.children.forEach(child => {
          const childLi = document.createElement('li');
          childLi.className = 'digb-home-grid-child-item';
          
          const childLink = document.createElement('a');
          childLink.href = child.link;
          childLink.className = 'digb-home-grid-child-link';
          
          // Add image if available
          if (child.image) {
            const img = document.createElement('img');
            img.src = child.image;
            img.alt = child.title;
            img.className = 'digb-home-grid-child-image';
            childLink.appendChild(img);
          }
          
          // Add title
          const title = document.createElement('span');
          title.textContent = child.title;
          title.className = 'digb-home-grid-child-title';
          childLink.appendChild(title);
          
          childLi.appendChild(childLink);
          childrenUl.appendChild(childLi);
        });
        
        li.appendChild(categoryLink);
        li.appendChild(childrenUl);
        ul.appendChild(li);
      });
      
      container.appendChild(ul);
    })
    .catch(error => {
      console.error('Error loading digb-home-grid.json:', error);
    });
}

// Check if we have data-json-url attribute and initialize
document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('digb-home-grid-extras');
  if (container && container.hasAttribute('data-json-url')) {
    const jsonUrl = container.getAttribute('data-json-url');
    initDIGBHomeGridExtras(jsonUrl);
  }
});